export * from "./SecondaryHeadingContent";